import { type CreateTipoDocumentoEmpresaServiciosModel, type DetailTipoDocumentoEmpresaServiciosModel } from "@api/api";

export class CreateTipoDocumentoEmpresaServicios implements CreateTipoDocumentoEmpresaServiciosModel {
  IdEmpresaServicios: string = '';
  Nombre: string = '';
  AplicaPersonaFisica: boolean = false;
  AplicaPersonaJuridica: boolean = false;

  constructor(data?: Partial<CreateTipoDocumentoEmpresaServicios>) {
    Object.assign(this, data);
  }

  public createFromTipoDocumentoDetail(tipoDocumento: DetailTipoDocumentoEmpresaServiciosModel): CreateTipoDocumentoEmpresaServicios{
    Object.assign(this, tipoDocumento);
    return this;
  }
}